<template>
  <div class="Category">
    <el-popover
      placement="bottom-start"
      :append-to-body="false"
      trigger="click"
      @show="popoverShow"
      v-model="show"
    >
      <div class="sort">
        <el-scrollbar class="list">
          <div
            v-for="(item, index) in hierarchyList"
            :key="index"
            @click="changeChildren(item)"
            :class="id === item.id ? 'active' : ''"
          >
            {{ item.value }}
          </div>
        </el-scrollbar>
        <div class="right">
          <div class="item" v-for="(item, index) in children" :key="index">
            <span class="name" @click="handleChildren(item)">
              {{ item.value }}
            </span>
            <!-- <div class="children">
              <span
                v-for="(childrenItem, childrenIndex) in item.children"
                :key="childrenIndex"
              >
                {{ childrenItem.bvnmpzigqwuyexo7 }}
              </span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="title" slot="reference">
        <img src="../assets/img/home/sort.png" alt="" />
        商品分类
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    hierarchyList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      id: '',
      children: [],
      show: false
    }
  },
  components: {},
  created () { },
  computed: {},
  mounted () { },
  methods: {
    popoverShow () {
      this.show = true
      if (this.hierarchyList && this.hierarchyList.length > 0) {
        this.id = this.hierarchyList[0].id
        this.children = this.hierarchyList[0].children
      }
    },
    changeChildren (data) {
      this.id = data.id
      this.children = data.children
    },
    handleChildren (item) {
      this.show = false
      this.$router.push(`/mall/show/goodsList/1/all?sort=${item.id}`)
    }
  },
}
</script>
<style lang='less' scoped>
@import '../assets/css/var.less';
.title {
  width: 200px;
  height: 40px;
  background: @thirdColor;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  margin-right: 40px;
  cursor: pointer;
  img {
    margin-right: 5px;
  }
}
/deep/.el-popover {
  margin: 2px 0 0;
  padding: 0;
  background-color: rgba(0, 0, 0, 0);
  box-shadow: 0 0 0 0;
  border: 0;
  top: 182px !important;
  .popper__arrow {
    display: none;
  }
}
.sort {
  height: 500px;
  display: flex;
  justify-content: flex-start;
  .list {
    width: 200px;
    height: 500px;
    background-color: rgba(0, 0, 0, 0.6);
    overflow-y: auto;
    overflow-x: hidden !important;
    /deep/.el-scrollbar__wrap {
      overflow-x: hidden;
    }
    div {
      line-height: 44px;
      color: #fff;
      font-size: 16px;
      padding: 0 0 0 16px;
      cursor: pointer;
    }
    .active {
      background: #000;
    }
  }
  .right {
    width: 1000px;
    height: 500px;
    background: rgba(251, 251, 251, 0.96);
    padding: 20px 40px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    overflow-y: auto;
    .item {
      margin-bottom: 16px;
      // display: flex;

      .name {
        width: 150px;
        text-align: right;
        font-size: 14px;
        color: #666;
        // font-weight: bold;
        margin-right: 20px;
        // padding: 16px 0 0;
        cursor: pointer;
      }
      .children {
        width: 100%;
        border-bottom: 1px dashed #666;
        padding: 16px 0 0;
        display: flex;
        flex-wrap: wrap;
        span {
          display: block;
          font-size: 14px;
          color: #666;
          margin-right: 20px;
          margin-bottom: 14px;
        }
      }
      &:last-child {
        .children {
          border-bottom: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Category.vue